import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const defaultState = {
  player: null,
  isPlay: false,
  playerCurrentTime: 0,
  playerDuration: 0,
  playerTracks: [],
  playerOriginalTracks: [],
  playerCurrentTrack: null,
  playerSeeking: false,
};

export default {
  state: defaultState,
  getters,
  actions,
  mutations,
};
